import { C } from "./constants";

export default function GaugeSVG({ value = 20 }) {
  const r = 62, cx = 100, cy = 88;
  const p = (deg, rad = r) => ({ x: cx + rad * Math.cos(deg * Math.PI / 180), y: cy + rad * Math.sin(deg * Math.PI / 180) });
  const va = v => 150 + v * 2.4;
  const arc = (v0, v1) => {
    const a0 = va(v0), a1 = va(v1), s = p(a0), e = p(a1);
    return `M${s.x.toFixed(1)} ${s.y.toFixed(1)} A${r} ${r} 0 ${(a1 - a0) > 180 ? 1 : 0} 1 ${e.x.toFixed(1)} ${e.y.toFixed(1)}`;
  };
  const tip = p(va(value), r * 0.84);


  return (
    <svg viewBox="0 0 200 130" className="w-full max-h-[170px]">
      <path d={arc(0,100)} stroke="#F1F5F9" strokeWidth={15} fill="none" strokeLinecap="round"/>
      {[[0,30,C.red],[30,60,C.orange],[60,80,C.blue],[80,100,C.green]].map(([f,t,c]) => (
        <path key={f} d={arc(f,t)} stroke={c} strokeWidth={12} fill="none" strokeLinecap="butt" opacity={0.88}/>
      ))}
      {[0,25,50,75,100].map(v => {
        const pt = p(va(v), r + 18);
        return <text key={v} x={pt.x.toFixed(1)} y={pt.y.toFixed(1)} textAnchor="middle" dominantBaseline="middle" fontSize={7.5} fill="#94A3B8">{v}</text>;
      })}
      <line x1={cx} y1={cy} x2={tip.x.toFixed(1)} y2={tip.y.toFixed(1)} stroke="#1E293B" strokeWidth={3} strokeLinecap="round"/>
      <circle cx={cx} cy={cy} r={8} fill="#1E293B"/>
      <circle cx={cx} cy={cy} r={3.5} fill="#fff"/>
      <text x={cx} y={cy+24} textAnchor="middle" fontSize={18} fontWeight="800" fill="#1E293B">{value}%</text>
      <text x={cx} y={cy+37} textAnchor="middle" fontSize={9} fill="#94A3B8">Overall Efficiency</text>
    </svg>
  );
}
